import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LANGUAGES } from "@/lib/i18n";
import { AutoBIMLogo, Wordmark } from "@/components/Brand";

export default function LanguagePicker() {
  const { lang, setLang } = useAuth();
  const isAr = lang === "ar";
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";

  return (
    <div className="min-h-screen abl-grid-bg">
      <div className="mx-auto max-w-lg px-5 py-12">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <AutoBIMLogo size={64} />
          <Wordmark />
          <h1 className="text-2xl font-black">{isAr ? "اختر لغتك" : "Choose your language"}</h1>
          <p className="text-sm text-muted-foreground">{isAr ? "يمكنك تغييرها لاحقاً في أي وقت" : "You can change this anytime later"}</p>
        </div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`pick-lang-${l.code}`}
              onClick={async () => {
                await setLang(l.code);
                navigate(next, { replace: true });
              }}
              className={`flex items-center gap-3 rounded-xl border p-3.5 text-start transition-colors ${
                l.code === lang ? "border-primary bg-primary/10" : "border-border bg-card/50 hover:border-primary/50"
              }`}
            >
              <span className="text-2xl">{l.flag}</span>
              <div className="flex-1">
                <div className="font-bold">{l.nativeName}</div>
                <div className="text-xs text-muted-foreground">{l.englishName}</div>
              </div>
              {l.code === lang && <Check size={18} className="text-primary" />}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
